import React, { memo, useEffect, useReducer, useState } from "react";
import useApi from "../../hooks/useApi";
import Preloader from "../../components/Preloader";
import caseCompareColumns from "../../components/Case/caseCompareColumn";
import { LocaleLoading, LocaleNotFound } from "../../components/core/Table/tableUtils";
import Table from "../../components/core/Table";
import { objectsArrayToFormData, renderDate } from "../../utils";
import { SmallRightArrow } from "../../components/Public/markup/icons";
import PersonalCabinet from "../PersonalCabinet";
import isEqual from "lodash/isEqual";
import Checkbox from "../../components/core/Checkbox";
import uniq from "lodash/uniq";
import without from "lodash/without";
import { useModal } from "react-modal-hook";
import PanModal from "../../components/core/PanModal";
import FixationsNew from "../Fixations/fixationsNew";
import Button from "../../components/core/Button";
import SubmitButton from "../../components/SubmitButton";
import SearchInp from "../../components/core/SearchInput";
import useDebounceState from "../../hooks/useDebounceState";
import useUniversalReducer from "../../hooks/useUniversalReducer";
import SelectFilter from "../../components/FilterRealty/SelectFilter";
import { dealsColumns } from "../Crm/columns";
import { Table as AntdTable } from "antd";
import { useHistory } from "react-router-dom";
import { filterToParamDeals } from "./utils";
import DatepickerDropdown from "../../components/core/DatepickerDropdown";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { get, set } from "lodash";
import EmptyTable from "../../components/core/EmptyTable";

const reorder = (list, startIndex, endIndex) => { // TO DO посмотреть в след раз, может вынести в компонент, если часто используем dnd
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const NewDeals = () => {

  const { data: {
    deals = [],
    filters = {},
    tableSettings,
    tableColumns
  },
    isLoading,
    refresher,
    isRefreshing,
    loadMore: loadMoreRequest,
    moreIsLoading,
    send,
    isSending,
    setData
  } = useApi({
    payload: ["panpartner:deals.ajax", "getDealList", { isGetFilter: 1 }],
    processData: (resp, prev) => ({
      ...prev,
      ...resp,
      tableColumns: resp?.tableSettings?.columns ? resp?.tableSettings?.columns.map(values => ({ ...values, visible: values.visible === "true" || values.visible === true })) : [] //:(
    })
  })

  const saveColumns = (params) => {
    const formdata = objectsArrayToFormData(tableColumns, "settings[columns]")
    formdata.append("type", "tableDealsSettings")
    send(["panpartner:deals.ajax", "setTableSettings", formdata])
  }

  const history = useHistory();

  const [selectedObjects, setSelectedObjects] = useState([]);
  const selectItems = id => setSelectedObjects(prev => uniq(prev.concat(id)))
  const deselectItems = id => setSelectedObjects(prev => without(prev, ...(Array.isArray(id) ? id : [id])))
  const toggleItems = (id, checked) => checked ? selectItems(id) : deselectItems(id)

  const dealsColumns = [
    {
      title: () => {
        const allIds = deals.map(item => item.id).sort()
        const checked = isEqual(allIds, [...selectedObjects].sort())
        return <Checkbox
          id={'all'}
          view="invert"
          checked={checked}
          onChange={e => toggleItems(allIds, e.target.checked)}
        />
      },
      dataIndex: 'id',
      key: 'id',
      width: 50,
      render: (id) => (
        <Checkbox
          id={id}
          view="invert"
          checked={selectedObjects.includes(id)}
          onChange={e => toggleItems(id, e.target.checked)}
        />
      ),
    },
    {
      title: "Клиент",
      dataIndex: "client",
      render: (client, { clientPhone, clientEmail }) =>
        <div>
          <div><b>{client}</b></div>
          <div>{clientPhone}</div>
          <div>{clientEmail}</div>
        </div>
    },
    {
      title: "Застройщик",
      dataIndex: "builder",
    },
    {
      title: "Жк",
      dataIndex: "block",
    },
    {
      title: "Адрес",
      dataIndex: "address",
    },
    {
      title: "Агент",
      dataIndex: "agent",
    },
    {
      title: "Статус",
      dataIndex: "status",
    },
    {
      title: "Управляющий",
      dataIndex: "manager",
    },
    {
      title: "Дата создания",
      dataIndex: "dateCreate",
    },
    {
      title: "Дата брони",
      dataIndex: "dateBooking",
    },
    {
      title: "Дата завершения брони",
      dataIndex: "dateBookingEnd",
    },
    {
      title: "Сумма комиссии",
      dataIndex: "commission",
    },
    {
      title: "Дата выплаты комиссии",
      dataIndex: "datePaymentCommission",
    },
    {
      title: "Дата заявки",
      dataIndex: "dateCreate",
      // render: renderDate,
    },
    {
      title: "Сумма квартиры",
      dataIndex: "sum",
    },
    {
      title: "Тип недвижимости",
      dataIndex: "type",
    },
    {
      title: "Тип квартиры",
      dataIndex: "roomType",
    },
    {
      title: "Дата подписания договора",
      dataIndex: "dateSigningAgreement",

    },

  ]
    .filter(dealCol => !tableColumns?.length || tableColumns.find(col => col.id === dealCol.dataIndex)?.visible)
    .sort((a, b) => {
      if (!tableColumns) return 0

      const aIndex = tableColumns.findIndex(col => col.id === a.dataIndex)
      const bIndex = tableColumns.findIndex(col => col.id === b.dataIndex)
      return aIndex - bIndex
    });

  const [debouncedValues, debouncedHandleChange, setDebouncedValues] = useDebounceState({
    setState: (prev, v) => v,
    fn: search => refresher(["panpartner:deals.ajax", "getDealList", search ? { 'filter[title]': search } : {}]),
    defaultState: "",
    delay: 400
  })

  const onDragEnd = ({ source, destination }) => {

    if (!destination) return;

    setData((prev) => ({
      ...prev,
      tableColumns: reorder(prev.tableColumns, source.index, destination.index),
    }));
  };

  const selectTableColumn = (index, itemValues) => {

    setData(prev => {
      const row = prev.tableColumns.find((item, i) => i === index)
      row.visible = !row.visible;
      const tmp = [...prev.tableColumns]
      tmp.splice(index, 1, row)
      return {
        ...prev,
        tableColumns: tmp
      }
    })

  }

  const [dealsSettingsModal, closeDealsSettingsModal] = useModal(
    () => (
      <PanModal customClass="deals-settings-modal" title={'Настроить видимость столбцов'} closeModal={closeDealsSettingsModal}>
        <div className="deals-settings-modal__over">

          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable" direction="vertical"  >
              {(provided, snapshot) => (
                <div
                  ref={ref => {
                    provided.innerRef(ref)
                  }}
                  {...provided.droppableProps}
                  className="deals-settings-modal__group"
                  style={{ padding: 20 }}
                >

                  {tableColumns.map((item, index) => (
                    <Draggable
                      key={item.id}
                      draggableId={`item-${item.id}`}
                      index={index}
                      isDragDisabled={false}
                    >
                      {provided => <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <Checkbox id={`chck-${item.id}`} view="red" labelText={item.title} checked={item.visible} onChange={e => selectTableColumn(index, item)} />
                      </div>}
                    </Draggable>

                  ))}

                </div>
              )}
            </Droppable>

          </DragDropContext>

        </div>
        <div className="deals-settings-modal__btns">
          <Button buttonType='secondary' type="button" onClick={closeDealsSettingsModal}>Отменить</Button>
          <SubmitButton className="btn btn_primary h6" type="button" onClick={() => {
            saveColumns()
            closeDealsSettingsModal()
          }}>
            Сохранить
          </SubmitButton>
        </div>

      </PanModal>
    ),
    [tableColumns, selectTableColumn,],
  );

  /* const [dealsSettingsModal, closeDealsSettingsModal] = useModal( //TO DO del
     () => (
       <PanModal customClass="deals-settings-modal" title={'Настроить видимость столбцов'} closeModal={closeDealsSettingsModal}>
         <div className="deals-settings-modal__over">
           <div className="deals-settings-modal__group">
             <Checkbox id="x1" view="red" labelText={`Клиент`} />
             <Checkbox id="x2" view="red" labelText={`Квартира`} />
             <Checkbox id="x3" view="red" labelText={`Статус`} />
             <Checkbox id="x4" view="red" labelText={`Дата брони`} />
             <Checkbox id="x5" view="red" labelText={`Сумма комиссии`} />
             <Checkbox id="x6" view="red" labelText={`Тим квартиры`} />
           </div>
           <div className="deals-settings-modal__group">
             <Checkbox id="x7" view="red" labelText={`Застройщик`} />
             <Checkbox id="x8" view="red" labelText={`Адрес`} />
             <Checkbox id="x9" view="red" labelText={`Управляющий`} />
             <Checkbox id="x10" view="red" labelText={`Дата завершения брони`} />
             <Checkbox id="x11" view="red" labelText={`Дата выплаты комиссии`} />
             <Checkbox id="x12" view="red" labelText={`Тип недвижимости`} />
           </div>
           <div className="deals-settings-modal__group">
             <Checkbox id="x13" view="red" labelText={`Жк`} />
             <Checkbox id="x14" view="red" labelText={`Агент`} />
             <Checkbox id="x15" view="red" labelText={`Дата создания`} />
             <Checkbox id="x16" view="red" labelText={`Дата подписания договора`} />
             <Checkbox id="x17" view="red" labelText={'Сумма квартиры'} />
           </div>
         </div>
         <div className="deals-settings-modal__btns">
           <Button buttonType='secondary'>Отменить</Button>
           <SubmitButton className="btn btn_primary h6" type="button">Сохранить</SubmitButton>
         </div>
       </PanModal>
     ),
     [],
   ); */

  const {
    state: filterState,
    setValue,
    reset,
    setValues
  } = useUniversalReducer({});

  const filterDates = (v) => {
    const formattedDates = {};
    for (const key in v) {
      if (Object.hasOwnProperty.call(v, key)) {
        const date = new Date(v[key]);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        formattedDates[key] = `${day}.${month}.${year}`;
      }
    }
    return formattedDates
  }

  const [selectDates, setSelectDates] = useState({})
  function formatDate(inputDate) {
    const parts = inputDate.split('.');
    const formattedDate = `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
    return formattedDate;
  }
  useEffect(() => {
    if (!filters) return
    const params = filterToParamDeals({}, filterState)
    if (params['filter[dateCreate]']) {
      delete params['filter[dateCreate]'];
      params['filter[dateCreate][min]'] = formatDate(selectDates.startDate)
      params['filter[dateCreate][max]'] = formatDate(selectDates.endDate)
    }
    send(["panpartner:deals.ajax", "getDealList", params]).then(resp => setData(prev => ({ ...prev, ...resp })))
  }, [filterState])



  if (isLoading) return <Preloader loading={true} />;

  return (
    <>
      <PersonalCabinet />
      <section className="section section_view_white orders no-header-profile">
        <div className="wrapper">
          <h3 className="h3" style={{ marginBottom: 20 }}>Сделки</h3>

          <div className="cabinet-deals-filter">
            <SearchInp
              value={debouncedValues}
              onChange={e => debouncedHandleChange(e.target.value)}
              isSearching={isRefreshing}
              reset={() => debouncedHandleChange("")}
              placeholder={'Фио клиента'}
            />

            <div className="crm-filters-header__select">
              <SelectFilter
                items={filters?.block}
                filterValues={filterState.block}
                onChange={v => setValue("block", v)}
                isAutocomplete={filters?.block?.length > 5}
                wrapperClass={"custom-select"}
                data={{
                  title: "Жилой комплекс",
                  autocompleteTitle: "Введите название ЖК",
                  identity: "block",
                }}
              />
            </div>

            <div className="crm-filters-header__select">
              <SelectFilter
                items={filters?.builder}
                filterValues={filterState.builder}
                onChange={v => setValue("builder", v)}
                isAutocomplete={filters?.builder?.length > 5}
                wrapperClass={"custom-select"}
                data={{
                  title: "Застройщик",
                  autocompleteTitle: "Введите название Застройщика",
                  identity: "builder",
                }}
              />
            </div>

            <div className="crm-filters-header__select">
              <SelectFilter
                items={filters?.status}
                filterValues={filterState.status}
                onChange={v => setValue("status", v)}
                isAutocomplete={filters?.status?.length > 5}
                wrapperClass={"custom-select"}
                data={{
                  title: "Статус",
                  autocompleteTitle: "Статус",
                  identity: "status",
                }}
              />
            </div>

            <div className="crm-filters-header__select">
             {!!filters?.agent && <SelectFilter
                items={filters?.agent}
                filterValues={filterState.agent}
                onChange={v => setValue("agent", v)}
                isAutocomplete={filters?.agent?.length > 5}
                wrapperClass={"custom-select"}
                data={{
                  title: "Агент",
                  autocompleteTitle: "Агент",
                  identity: "agent",
                }}
              />}
            </div>
            <div className="crm-filters-header__select">
              <DatepickerDropdown
                onChange={v => {
                  setSelectDates(filterDates(v))
                  setValue("dateCreate", v)
                }}
                value={filterState.dateCreate || {
                  startDate: null,
                  endDate: null,
                }}

                label={Object.keys(selectDates).length !== 0 ? selectDates.startDate + ' - ' + selectDates.endDate : false}
                clearFilters={() => {
                  setSelectDates(
                    {
                      startDate: filterDates(filters?.dateCreate.range).min,
                      endDate: filterDates(filters?.dateCreate.range).max
                    }
                  )
                  setValues(
                    {
                      ...filterState, dateCreate:
                      {
                        ...filterState.dateCreate,
                        endDate: new Date(filters?.dateCreate.range.max),
                        startDate: new Date(filters?.dateCreate.range.min)
                      }
                    }
                  )
                }}
              />
            </div>

          </div>


          <div className="cabinet-deals-settings" onClick={dealsSettingsModal}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 15.8247C14.1123 15.8247 15.8247 14.1123 15.8247 12C15.8247 9.88767 14.1123 8.17529 12 8.17529C9.88767 8.17529 8.17529 9.88767 8.17529 12C8.17529 14.1123 9.88767 15.8247 12 15.8247Z" stroke="#8790E5" stroke-linecap="round" stroke-linejoin="round" /><path d="M16.4377 6.98752C16.6403 7.17379 16.8315 7.36503 17.0114 7.56122L19.1873 7.87251C19.542 8.48792 19.8152 9.14683 20 9.83267L18.6773 11.5931C18.6773 11.5931 18.7007 12.1349 18.6773 12.4058L20 14.1673C19.8158 14.8534 19.5426 15.5124 19.1873 16.1275L17.0114 16.4377C17.0114 16.4377 16.6375 16.8287 16.4377 17.0114L16.1275 19.1873C15.5121 19.542 14.8532 19.8152 14.1673 20L12.4058 18.6773C12.1354 18.7007 11.8635 18.7007 11.5931 18.6773L9.83267 20C9.1466 19.8158 8.48761 19.5426 7.87251 19.1873L7.56122 17.0114C7.36574 16.8255 7.17344 16.6343 6.98752 16.4377L4.81275 16.1275C4.45804 15.5121 4.18484 14.8532 4 14.1673L5.32271 12.4058C5.32271 12.4058 5.29827 11.864 5.32271 11.5931L4 9.83267C4.18418 9.1466 4.45742 8.48761 4.81275 7.87251L6.98752 7.56122C7.17344 7.36467 7.36574 7.17344 7.56122 6.98752L7.87251 4.81275C8.48792 4.45804 9.14683 4.18484 9.83267 4L11.5931 5.32271C11.8635 5.29827 12.1355 5.29827 12.4058 5.32271L14.1673 4C14.8534 4.18418 15.5124 4.45742 16.1275 4.81275L16.4377 6.98752Z" stroke="#8790E5" stroke-linecap="round" stroke-linejoin="round" /></svg>
            <span>Настроить видимость столбцов</span>
          </div>
          <div className="crm-table crm-table_filters cabinet-deals-table">
            {/*<Table*/}
            {/*  rowKey="id"*/}
            {/*  columns={dealsColumns}*/}
            {/*  dataSource={deals}*/}
            {/*  pagination={false}*/}
            {/*  customPagination={true}*/}
            {/*  // locale={LocaleNotFound}*/}
            {/*/>*/}

            {!deals?.length && <EmptyTable title="Ничего не найдено" />}
            {!!deals?.length && <AntdTable
              rowKey="id"
              columns={dealsColumns}
              dataSource={isSending ? false : deals}
              locale={isSending ? LocaleLoading : LocaleNotFound}
              pagination={false}
              rowClassName={(record, index) => ((index + 1) % 2 === 0 ? "ant-table-second-color" : "")}
              onRow={row => ({
                onClick: e => {
                  history.push(`/crm/deals/${row.id}`)
                }
              })}
            />}
          </div>

        </div>
      </section>
    </>
  )
}

export default NewDeals
